const Divider = () => {
  return (
    <div style={{ padding: "0 5px" }}>
      <div
        style={{
          width: "1px",
          height: "25px",
          backgroundColor: "white",
        }}
      ></div>
    </div>
  );
};

export { Divider };
